// Product page: option pills, automatic price breaks, add-ons, and add to cart (with artwork upload).
(function () {
  const dataEl = document.getElementById('product-data'); if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const form = document.getElementById('pform'); if (!form) return;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmtNum = (n) => n.toLocaleString('en-CA');
  const money = (cents) => '$' + (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const moneyShort = (cents) => money(cents).replace(/\.00$/, '');
  const qtyIn = $('[data-qty]'), idIn = $('[data-variant-id]'), msg = $('[data-qty-msg]'), err = $('[data-err]');
  const tierMode = D.mode === 'tier', packMode = D.mode === 'pack', unit = D.unit || 1, qi = D.qtyOpt;

  // ---- tiers ----
  const parseTier = (label) => {
    const s = String(label).replace(/,/g, '');
    let m = s.match(/^(\d+)\s*\+$/); if (m) return { min: +m[1], max: Infinity };
    m = s.match(/^(\d+)\s*-\s*(\d+)$/); if (m) return { min: +m[1], max: +m[2] };
    m = s.match(/^(\d+)$/); if (m) return { min: +m[1], max: +m[1] };
    return { min: 1, max: Infinity };
  };
  const tierLabel = (t) => {
    const f = (n) => fmtNum(n * unit);
    return t.max === Infinity ? f(t.min) + '+' : (t.min === t.max ? f(t.min) : f(t.min) + ' – ' + f(t.max));
  };

  // currently selected values for every option (except quantity in tier mode)
  const sel = {};
  $$('.opt[data-opt]', form).forEach(fs => { const i = +fs.dataset.opt; const c = $('input:checked', fs) || $('input', fs); if (c) { c.checked = true; sel[i] = c.value; } });
  const matches = (v, skip) => v.options.every((o, i) => i === skip || sel[i] === undefined || sel[i] === o);

  function tiersForSelection() {
    return D.variants.filter(v => matches(v, qi)).map(v => ({ v, ...parseTier(v.options[qi]) })).sort((a, b) => a.min - b.min);
  }
  function currentVariant() {
    if (tierMode && qi >= 0) {
      const ts = tiersForSelection(); if (!ts.length) return null;
      const q = Math.max(1, parseInt(qtyIn.value, 10) || 0);
      return (ts.find(t => q >= t.min && q <= t.max) || (q < ts[0].min ? ts[0] : ts[ts.length - 1])).v;
    }
    return D.variants.find(v => matches(v, -1)) || null;
  }

  // an option value is offered if some variant has it together with the options chosen above it;
  // when an earlier choice changes, later choices are repaired to the first valid value
  const skipQ = (i) => tierMode && i === qi;
  const okWithPrev = (i, val) => D.variants.some(v => v.options[i] === val && v.options.every((o, j) => j >= i || skipQ(j) || sel[j] === undefined || sel[j] === o));
  function refreshPills() {
    $$('.opt[data-opt]', form).sort((x, y) => x.dataset.opt - y.dataset.opt).forEach(fs => {
      const i = +fs.dataset.opt; const inputs = $$('input', fs);
      inputs.forEach(inp => { inp.disabled = !okWithPrev(i, inp.value); });
      const checked = inputs.find(x => x.checked);
      if (!checked || checked.disabled) { const first = inputs.find(x => !x.disabled); if (first) { first.checked = true; sel[i] = first.value; } }
    });
  }
  let lastChanged = 0;

  function renderTiers() {
    const tb = $('[data-tiers] tbody'); if (!tb) return;
    const ts = tiersForSelection(); const cur = currentVariant();
    tb.innerHTML = ts.map(t => `<tr class="${cur && t.v.id === cur.id ? 'on' : ''}"><td>${tierLabel(t)}</td><td>${money(t.v.price)}</td></tr>`).join('');
    if (ts.length) {
      const min = Math.max(D.min || 1, ts[0].min);
      qtyIn.min = min;
      if (!qtyIn.dataset.touched) qtyIn.value = min;
    }
  }
  function renderPackPrices() {
    if (!packMode || qi < 0) return;
    $$('[data-pack-price]', form).forEach(sm => {
      const v = D.variants.find(v => v.options[qi] === sm.dataset.packPrice && v.options.every((o, i) => i === qi || sel[i] === undefined || sel[i] === o));
      sm.textContent = v ? moneyShort(v.price) : '—';
    });
  }

  // ---- add-ons ----
  const addonEls = $$('[data-addon]', form);
  const addons = D.addons.map(a => {
    const el = addonEls.find(e => e.dataset.addon === a.handle); const box = el && $('.a-opts', el);
    const own = a.options.map((name, i) => ({ name, i })).filter(o => !D.options.includes(o.name));
    const selects = own.map(o => {
      const vals = [...new Set(a.variants.map(v => v.options[o.i]))];
      if (vals.length < 2) return { ...o, el: null, value: vals[0] };
      const s = document.createElement('select'); s.setAttribute('aria-label', o.name);
      s.innerHTML = vals.map(v => `<option>${v}</option>`).join(''); box && box.appendChild(s);
      return { ...o, el: s };
    });
    (a.fields || []).filter(Boolean).forEach(f => {
      const [kind, label, choices] = f.replace(/^field:/, '').split('|');
      const s = document.createElement(kind === 'select' ? 'select' : 'input'); s.setAttribute('aria-label', label); s.dataset.prop = label;
      if (kind === 'select') s.innerHTML = (choices || '').split(';').map(c => `<option>${c}</option>`).join(''); else s.placeholder = label;
      box && box.appendChild(s);
    });
    const cb = el && $('input[type=checkbox]', el);
    const resolve = (mainVariant) => a.variants.find(v => a.options.every((name, i) => {
      const mi = D.options.indexOf(name);
      if (mi >= 0) return mainVariant && mainVariant.options[mi] === v.options[i];
      const s = selects.find(x => x.i === i); return !s || (s.el ? s.el.value : s.value) === v.options[i];
    }));
    const props = () => { const p = { _For: D.title }; box && $$('[data-prop]', box).forEach(x => { if (x.value) p[x.dataset.prop] = x.value; }); return p; };
    const on = () => a.required || (cb && cb.checked);
    if (box) box.addEventListener('change', update);
    cb && cb.addEventListener('change', update);
    return { a, el, cb, resolve, props, on };
  });

  // ---- totals ----
  function qty() { return Math.max(0, parseInt(qtyIn.value, 10) || 0); }
  function update() {
    refreshPills();
    if (tierMode) renderTiers();
    renderPackPrices();
    const v = currentVariant(); const q = qty();
    if (v) {
      idIn.value = v.id;
      $('[data-price]').textContent = money(v.price);
      const note = $('[data-price-note]');
      if (tierMode) note.textContent = (unit > 1 ? 'per 1,000' : 'each') + ' at ' + fmtNum(q * unit) + (unit > 1 ? ' pieces' : '');
      const sku = $('[data-sku]'); if (sku && v.sku) sku.textContent = v.sku;
    }
    // minimum order value (e.g. $35): raise the minimum quantity for the selected option
    let minOrderQ = 0;
    if (D.minOrder && v && v.price > 0) {
      const perUnit = v.price;
      minOrderQ = Math.ceil(D.minOrder / perUnit);
      if (!packMode) {
        qtyIn.min = Math.max(D.min || 1, minOrderQ, tierMode ? (+qtyIn.min || 1) : 0);
        if (!qtyIn.dataset.touched && qty() < +qtyIn.min) qtyIn.value = qtyIn.min;
      }
    }
    const q2 = qty();
    let total = v ? v.price * q2 : 0, extra = 0;
    addons.forEach(x => {
      const av = x.resolve(v); const priceEl = x.el && $('[data-addon-price]', x.el);
      if (x.el) x.el.style.opacity = av ? 1 : .5;
      if (x.cb && !x.a.required) x.cb.disabled = !av;
      if (priceEl) priceEl.textContent = av ? '+' + money(av.price) + (x.a.per === 'order' ? ' one-time' : (packMode ? ' per set' : (unit > 1 ? ' per 1,000' : ' each'))) : 'not available for this option';
      if (av && x.on()) extra += av.price * (x.a.per === 'order' ? 1 : q2);
    });
    total += extra;
    $('[data-total]').textContent = money(total);
    $('[data-total-note]').textContent = extra ? 'Includes add-ons and fees · before tax' : 'Before tax';
    // quantity messages
    let m = '';
    const min = +qtyIn.min || 1, max = qtyIn.max ? +qtyIn.max : null;
    if (D.minOrder && v && q2 * v.price < D.minOrder) m = `Minimum order is ${moneyShort(D.minOrder)}. That's ${fmtNum(minOrderQ)} for this option.`;
    else if (q2 < min) m = `Minimum order is ${fmtNum(min * unit)}.`;
    else if (max && q2 > max) m = `For more than ${fmtNum(max)}, please request a quote.`;
    else if (!v) m = 'That combination isn’t available. Please choose another option.';
    msg.textContent = m; msg.hidden = !m;
    $('[data-atc]').disabled = !!m;
  }

  // events
  $$('.opt[data-opt] input', form).forEach(inp => inp.addEventListener('change', () => { const i = +inp.closest('.opt').dataset.opt; sel[i] = inp.value; lastChanged = i; update(); }));
  qtyIn.addEventListener('input', () => { qtyIn.dataset.touched = '1'; update(); });
  qtyIn.addEventListener('change', () => { const min = +qtyIn.min || 1; if (qty() < min) { qtyIn.value = min; update(); } });
  $$('[data-step]', form).forEach(b => b.addEventListener('click', () => {
    const step = tierMode ? (unit > 1 ? 1 : (qty() >= 1000 ? 100 : qty() >= 100 ? 50 : 1)) : 1;
    qtyIn.value = Math.max(+qtyIn.min || 1, qty() + (+b.dataset.step) * step); qtyIn.dataset.touched = '1'; update();
  }));
  $$('.gal-thumbs button').forEach(b => b.addEventListener('click', () => { $('#gal-main').src = b.dataset.src; $$('.gal-thumbs button').forEach(x => x.classList.toggle('on', x === b)); }));
  const art = $('#artwork'); if (art) art.addEventListener('change', () => { const out = art.closest('.drop').querySelector('.drop-files'); const f = art.files[0]; out.textContent = f ? `${f.name} (${(f.size / 1048576).toFixed(1)} MB)` : ''; });

  // ---- add to cart ----
  form.addEventListener('submit', async (e) => {
    e.preventDefault(); update();
    const btn = $('[data-atc]'); if (btn.disabled) return;
    err.hidden = true;
    const f = art && art.files[0];
    if (f && f.size > 20 * 1024 * 1024) { err.textContent = 'That file is over 20 MB. Please add the order without it and send the file from our Send a File page.'; err.hidden = false; return; }
    btn.disabled = true; const label = btn.textContent; btn.textContent = 'Adding…';
    try {
      const fd = new FormData(form);
      ['opt0', 'opt1', 'opt2'].forEach(k => fd.delete(k));
      if (f === undefined || (art && !art.files.length)) fd.delete('properties[Artwork]');
      if (!fd.get('properties[Notes]')) fd.delete('properties[Notes]');
      const r = await fetch((window.UDP && UDP.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to cart.'); }
      const v = currentVariant(); const q = qty();
      const items = [];
      let cart = null;
      for (const x of addons) {
        const av = x.resolve(v); if (!av || !x.on()) continue;
        if (x.a.per === 'order') {
          cart = cart || await fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }));
          if (cart.items.some(it => it.variant_id === av.id)) continue;   // one setup fee per order
          items.push({ id: av.id, quantity: 1, properties: x.props() });
        } else items.push({ id: av.id, quantity: q, properties: x.props() });
      }
      if (items.length) {
        const r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r2.ok) throw new Error('Your item was added, but an add-on could not be. Please note it in the cart and we will sort it out.');
      }
      location.href = (window.UDP && UDP.routes.cart) || '/cart';
    } catch (ex) {
      err.textContent = ex.message; err.hidden = false; btn.disabled = false; btn.textContent = label;
    }
  });

  update();
})();
